import React from "react";

const Input = ({ Label, value, Placeholder, handlechange, type }) => {
  return (
    // This is the component used for Inputs used in the project

    <div className="w-full">
      <p className="text-sm font-semibold mb-[11px]">{Label}</p>
      <input
        type={type === "number" ? "number" : "text"}
        value={value}
        onChange={handlechange}
        className="w-full bg-white border  border-[#E0E0E0] text-gray-900 text-sm  p-2.5 rounded-md "
        placeholder={Placeholder}
      />
      {/* <p className="w-1/6 text-center font-medium max-[600px]:w-[60%] py-2  rounded-r-md  bg-[#E1EFFE] border border-[#86B8EE]">
        Months ago
      </p> */}
    </div>
  );
};

export default Input;
